export const indexRoute = "/";
export const blogRoute = "/blog";
export const biondRoute = "/biond";
export const businessRoute = "/business";
export const contactRoute = "/contact";
export const faqRoute = "/faq";
export const pricingRoute = "/pricing";
export const privacyPolicyRoute = "/privacy-policy";
export const termsOfServiceRoute = "/terms-of-service";
export const styleguideRoute = "/styleguide";
export const articleRoute = "/blog/:articleSlug";



// WEBPACK FOOTER //
// ./src/constants/routes.js